module.exports = __webpack_public_path__ + "img/phoneImg3.bbc62215.jpg";